<template>
    <div>
        <form class="login-form" novalidate="true" v-on:submit.prevent="changePassword"
              autocomplete="off">
            <loading-overlay :loading="startLoading"/>
            <div class="alert-container" v-if="errorMessage">
                <div class="fade-in-out alert alert-error" >
                    <div v-html="errorMessage"></div>
                </div>
            </div>
            <div class="change-password-form-container">
                <div v-if="!changePasswordSuccess">
                    <div>
                        <div class="col-12 change-password-warning-container">
                            <div class="row col-12 content">
                                <div class="justify-content-md-center icon-container">
                                    <font-awesome-icon icon="info-circle" class="icon" />
                                </div>
                                <p class="col text" v-html="CONSTANTS.NEW_PATTERNS_WARNING_TEXT" />
                            </div>
                            <div v-html="CONSTANTS.NEW_PATTERNS_WARNING_DETAILS"></div>
                        </div>
                        <div class="row form-field-row">
                            <div class="col-12">
                                <div class="username-div">Username</div>
                                <input v-model="userName" type="text" autocomplete="off"
                                       data-vv-validate-on="none"
                                       autocorrect="off" autocapitalize="off" name="Username"
                                       spellcheck="false" class="input-textfield" v-validate="'required'">
                                <span class="text-danger input-error-text" v-if="errors.has('Username')">{{errors.first('Username')}}</span>
                                <div class="input-error-text" v-if="isUserNameError">
                                    {{userNameErrorText}}
                                </div>
                            </div>
                        </div>
                        <div class="row form-field-row">
                            <div class="col-12">
                                <div>Current Password</div>
                                <input v-model="currentPassword" type="password" class="input-textfield" v-validate="'required'"
                                       data-vv-validate-on="none"
                                       name="Current Password" autocomplete="none">
                                <span class="text-danger input-error-text" v-if="errors.has('Current Password')">{{errors.first('Current Password')}}</span>
                                <div class="input-error-text" v-if="isCurrPassError">
                                    {{currPassErrorText}}
                                </div>
                            </div>
                        </div>
                        <div class="row form-field-row" id="newPassId">
                            <div class="col-12">
                                <div>New Password</div>
                                <input v-model="newPassword" type="password" class="input-textfield" @keyup="handleValidation"
                                       v-validate="'required|validateNewPasswordPolicies'"
                                       data-vv-validate-on="none"
                                       id="newPasswordId" name="New Password" autocomplete="none">
                                <span class="text-danger input-error-text" v-if="errors.has('New Password')">{{errors.first('New Password')}}</span>
                                <div class="input-error-text" v-if="isNewPassError">
                                    {{newPassErrorText}}
                                </div>
                                <b-popover v-on:show="handleValidation" target="newPasswordId" triggers="focus"
                                           placement="auto"
                                           container="newPassId" offset="5">
                                    <template slot="title">
                                        <div class="newPassHeader">Your new password must have</div>
                                    </template>
                                    <div>
                                        <password-policy-validation :domain="domain"
                                                                    :policy="policy"
                                                                    :newPwdValue="newPwdValue"
                                                                    v-on:passwordPolicyValidated="onPasswordPolicyValidated"/>
                                    </div>
                                </b-popover>
                            </div>
                        </div>
                        <div class="row form-field-row">
                            <div class="col-12">
                                <div>Confirm Password</div>
                                <input v-model="newPasswordConfirmation" type="password" class="input-textfield" v-validate="'required|validateConfirmPassword'"
                                       data-vv-validate-on="none" name="Confirm Password" autocomplete="none">
                                <span class="text-danger input-error-text" v-if="errors.has('Confirm Password')">{{errors.first('Confirm Password')}}</span>
                            </div>
                        </div>
                        <div class="row form-field-row change-password-button">
                            <div class="col-12 text-center text-sm-center text-lg-right">
                                <input class="btn flat-blue-btn" type="submit" v-bind:value="CONSTANTS.CHANGE_PASSWORD"/>
                            </div>
                        </div>
                    </div>
                </div>
                <change-password-success v-else/>
            </div>
        </form>
    </div>
</template>

<script>
    import * as CONSTANTS from "../store/constants";
    import domainUtilityMixin from "../mixins/DomainMixin";
    import PasswordPolicyValidation from "./PasswordPolicyValidation";
    import api from "../api";
    import ChangePasswordSuccess from "./ChangePasswordSuccess";
    import 'bootstrap/dist/js/bootstrap.js';
    import LoadingOverlay from "@/components/LoadingOverlay";
    import MixpanelMixin from "@/mixins/MixpanelMixin";
    import * as axios from 'axios';
    export default {
        name: 'ChangePasswordForm',
        components: {
            LoadingOverlay,
            ChangePasswordSuccess,
            PasswordPolicyValidation
        },
        mixins:[MixpanelMixin],
        data() {
            return {
                CONSTANTS,
                domain: this.$store.state.domain,
                showPolicies: false,
                userName: null,
                domains: [
                    CONSTANTS.ADS_DOMAIN
                ],
                currentPassword: null,
                axiosInstance:null,
                newPassword: null,
                newPasswordConfirmation: null,
                policy: null,
                changePasswordSuccess: false,
                newPwdValue: null,
                isUserNameError: false,
                isCurrPassError: false,
                isNewPassError: false,
                userNameErrorText: null,
                maxAttemptsError:null,
                errorMessage:null,
                currPassErrorText: null,
                newPassErrorText: null,
                confirmPassErrorText: null,
                policiesValidated: false,
                startLoading: false
            }
        },
        created() {
            let self = this;
            this.$validator.extend('required', {
                getMessage: field => field + " cannot be empty",
                validate: value =>  {
                    return value !== null && value !== "";
                }
            });
            this.$validator.extend('validateNewPasswordPolicies',{
                getMessage: CONSTANTS.BAD_NEW_PASSWORD_ERROR_TEXT,
                validate: value =>  {
                    return value && this.policiesValidated;
                }
            });
            this.$validator.extend('validateConfirmPassword',{
                getMessage: CONSTANTS.BAD_CONFIRM_PASSWORD_ERROR_TEXT,
                validate: value =>  {
                    return value === self.newPassword;
                }
            });
        },
        mounted() {
            this.setAxiosInstance();
            this.fetchPolicy();
            this.domain = this.$store.state.domain;
            this.trackEvent("Change Password");
            this.$validator.reset();
        },
        methods: {
            setAxiosInstance(){
                this.axiosInstance =  axios.create({
                    baseURL: process.env.VUE_APP_PASSWORD_MANAGEMENT_API
                });
            },
            changePassword() {
                this.isUserNameError = false;
                this.isNewPassError = false;
                this.isCurrPassError = false;
                this.errorMessage = null;
                this.maxAttemptsError = null;
                let that = this;
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.startLoading = true;
                        return api.changePassword({
                            "userName": this.userName,
                            "currentPassword": this.currentPassword,
                            "newPassword": this.newPassword,
                            "domain": this.domain
                        },this.axiosInstance).then(() => {
                            this.changePasswordSuccess = true;

                        }).catch(function (e) {
                            that.changePasswordSuccess = false;
                            let response = e.response;

                            if (null != response && null != response.data) {
                                let errorCode = response.data.errorCode;
                                if(errorCode == CONSTANTS.INTERNALSERVER_ERROR_STATUS_CODE){
                                    that.errorMessage = CONSTANTS.ERROR_TEXT;
                                }else{
                                    let errorMessage = response.data.errorMessage;
                                    if (null != errorMessage) {
                                        if (errorMessage === CONSTANTS.BAD_USER) {
                                            that.isUserNameError = true;
                                            that.userNameErrorText = CONSTANTS.BAD_USER_ERROR_TEXT;
                                        } else if (errorMessage === CONSTANTS.BAD_OLD_PASSWORD) {
                                            that.isCurrPassError = true;
                                            that.currPassErrorText = CONSTANTS.BAD_OLD_PASSWORD_ERROR_TEXT;
                                        } else if (errorMessage === CONSTANTS.BAD_NEW_PASSWORD) {
                                            that.isNewPassError = true;
                                            that.newPassErrorText = CONSTANTS.BAD_NEW_PASSWORD_ERROR_TEXT;
                                        } else if (errorMessage == CONSTANTS.MAX_ATTEMPTS_ERROR) {
                                            that.errorMessage = CONSTANTS.MAX_ATTEMPTS_ERROR_TEXT;
                                        } else {
                                            console.error(errorMessage);
                                            that.isUserNameError = true;
                                            that.userNameErrorText = errorMessage;
                                        }
                                    }
                                }
                            } else {
                                that.errorMessage = CONSTANTS.ERROR_TEXT;
                            }
                        })
                            .finally(() => {
                                if(this.userName){
                                    if(this.changePasswordSuccess){
                                        this.trackEvent("Change password - successful",this.userName);
                                    } else{
                                        this.trackEvent("Change password - failure ",this.userName);
                                    }
                                }
                                that.startLoading = false;
                            });
                    }
                });
            },
            fetchPolicy() {
                let that = this;
                return api.fetchPolicyByDomain(this.domain,this.axiosInstance)
                    .then(function (response) {
                        that.policy= response.data.policy;
                    }).catch(e => {
                        console.error("Error while loading policy info",e);
                    })
            },
            showPoliciesComponent(show) {
                this.showPolicies = show;
            },
            handleValidation() {
                this.newPwdValue = this.newPassword ? this.newPassword : "";
            },
            onPasswordPolicyValidated(validated) {
                this.policiesValidated = validated;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .change-password-button {
        margin-top: 30px;
        right: 0;
    }

    .username-div {
        display: inline-block;
    }
    
    .change-password-warning-container {
        color: #000000;
        background-color: white;
        font-size: 16px;
        font-style: italic;
        padding: 0;
    }

    .change-password-warning-container >>> ul li {
        font-size: 14px !important;
    }

    .change-password-warning-container .content {
        padding: 0;
        margin: 0;
    }

    .change-password-warning-container .text {
        padding: 0;
    }

    .change-password-warning-container .icon-container {
        padding: 0;
        margin-right: 10px;
    }

    .change-password-warning-container .icon {
        color: #FFC21A;
        width: 1.5rem;
        height: 1.5rem;
        margin: 5px 0px;
        padding: 0;
    }

    .fill-in-text {
        font-size: 14px;
        font-weight: bold;
        padding: 20px 0 20px 0;
        color: black;
    }
</style>
